import React, { Component } from 'react';
import serializeError from 'serialize-error';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import autoBind from "react-autobind";

import history from '../../history';
import logger from '../../common/logger';
import { SubmitQuestionnaire } from './SubmitQuestionnaire';
import api, { handleSearchError } from '../../common/api';
import updateState from '../../common/updateState';

export class SubmitQuestionnaireContainer extends Component {

  constructor(props) {
    super(props)
    autoBind(this);
    const params = queryString.parse(props.location.search)
    this.state = {
      busy: false,
      sessionId: params.sessionId,
      questions: [],
      answers: [],
      units: []
    }
  }

  componentDidMount() {
    updateState(this, {
      busy: true
    })
    this.getReviewQuestions()
  }

  getReviewQuestions() {
    api().
      get(`questionnaire/${this.state.sessionId}/reviewQuestions`).
      then(function(response) {

        const questions = response.data.questions
        const answers = response.data.answers || [] 

        updateState(this, {
          busy: false,
          questions: questions,
          answers: answers
        })

      }.bind(this)).
      catch(handleSearchError(`?sessionId=${this.state.sessionId}`))
  }

  back() {
    updateState(this, {
      busy: true
    })
    api().
      delete(`questionnaire/${this.state.sessionId}/answers`).
      then(function(response) {
        history.push({
          pathname: '/questionnaire',
          search: `?sessionId=${this.state.sessionId}`
        })
      }.bind(this)).
      catch((error) => {
        logger.error(error);
        history.push({
          pathname: '/error',
          search: `?sessionId=${this.state.sessionId}`,
          state: {
            error: serializeError(error)
          }
        })
      })
  }

  submit() {
    updateState(this, {
      busy: true
    });

    api().
      post(`questionnaire/${this.state.sessionId}/submit`, {
        //posting an empty object seems to be required by axios
      }).
      then(function(response) {
        const path = response.data.outcome !== undefined 
          && response.data.loading !== undefined
          ? "/test-result"
          : "/complete";

        history.push({
          pathname: path,
          search: `?sessionId=${this.state.sessionId}`,
          state: {
            redirectUrl: response.data.redirectUrl,
            outcome: response.data.outcome,
            loading: response.data.loading,
            requirements: response.data.requirements,
            exclusions: response.data.exclusions
          }
        });
      }.bind(this)).
      catch((error) => {
        logger.error(error);
        history.push({
          pathname: '/error',
          search: `?sessionId=${this.state.sessionId}`,
          state: {
            error: serializeError(error)
          }
        })
      })
  }

  render() {
    const { busy, questions, answers, units } = this.state
    return (
      <div>
        <SubmitQuestionnaire questions={questions} answers={answers} units={units} busy={busy} back={this.back} submit={this.submit} />
      </div>
    )
  }
}

SubmitQuestionnaireContainer.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  })
};




// WEBPACK FOOTER //
// ./src/components/submitQuestionnaire/SubmitQuestionnaireContainer.js